// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || window.location.hash;
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const session_id = params.get("session_id");

        if (!session_id) {
            navigate("/", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id });
                setUser(data.user);
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/feed", { replace: true, state: { user: data.user } });
            } catch (e) {
                navigate("/login", { replace: true });
            }
        })();
    }, [location.hash, navigate, setUser]);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-[#050505]" data-testid="auth-callback-loader">
            <div className="text-center">
                <Loader2 className="w-10 h-10 animate-spin text-[#FF5722] mx-auto" />
                <p className="mt-4 text-white/70 font-body">Connexion en cours...</p>
            </div>
        </div>
    );
}
